/*
 * yenko-image-protect.js
 * Light deterrent against casual image saving: blocks the right-click "Save image"
 * context menu and click-and-drag on images only (the rest of the page behaves normally).
 *
 * IMPORTANT: this is friction, not protection. It does NOT stop screenshots, browser
 * DevTools, "view source", direct Shopify CDN image URLs, or visitors with JS disabled.
 * Real protection for the artwork is the watermark baked into the product images.
 *
 * Uses capture-phase delegation on document so dynamically-added images (quick add,
 * cart drawer, product-media swaps) are covered without re-binding.
 */
(function () {
  'use strict';

  // True when the event happened on (or inside) a visual media element.
  function isImageTarget(el) {
    return !!(el && el.closest && el.closest('img, picture, svg, canvas'));
  }

  // Block the right-click context menu over images only.
  document.addEventListener(
    'contextmenu',
    function (e) {
      if (isImageTarget(e.target)) e.preventDefault();
    },
    { capture: true }
  );

  // Block drag-to-desktop / drag-to-new-tab of images.
  document.addEventListener(
    'dragstart',
    function (e) {
      if (e.target && e.target.tagName === 'IMG') e.preventDefault();
    },
    { capture: true }
  );
})();
